/**
 * Regex to match no-crawl-id attribute values in the exact format:
 * [(ACX-KEY)]
 *
 * Purpose:
 * - Used for no-crawl placeholders that are intentionally left empty in the
 *   server-rendered HTML so search engines won't see the real text.
 * - The client replaces these placeholders with disclosure data after page load.
 *
 * Capture Group 1:
 * - Extracts the "ACX-KEY" part for lookup in disclosure data.
 */
export const NO_CRAWL_ID_PLACEHOLDER_REGEX = /^\[\((ACX-[^)]+)\)\]$/

export const ALLOWED_SUBDOMAIN_REGEX =
  /^https:\/\/[a-zA-Z0-9-]+\.((dev|stg)\.(ffngcp\.com|fdrgcp\.com))$/

export const DOMAIN_EXPRESSION_REGEX =
  /^(?:.*?\.)?([a-zA-Z0-9\-_]{3,}\.(?:\w{2,8}|\w{2,4}\.\w{2,4}))$/
